import { minutesToHours } from "PFCore/helpers/date";
import React, { ReactNode } from "react";

import css from "../bars.module.scss";
import { BookingBarData } from "./booking_bar_provider";

type BookingPillLabelProps = {
  title?: string;
  duration: number;
  load: number;
  icon: ReactNode;
  showTitle: boolean;
  showLabel: boolean;
  showIcon: boolean;
  state: BookingBarData["state"];
};

export const BookingPillLabel = ({
  title,
  duration,
  load,
  icon,
  showTitle,
  showLabel,
  showIcon,
  state
}: BookingPillLabelProps): JSX.Element => {
  const pillLabel = state !== "pending" ? `${Math.round(load * 100)}% (${minutesToHours(duration)}h)` : "-";
  return (
    <div className={css.pillLabelContainer}>
      {showIcon && <div className={css.pillLabelIcon}>{icon}</div>}
      <div className={css.pillLabel}>
        {showTitle && <span className={css.pillLabelTitle}>{title}</span>}
        {showLabel && <span className={css.pillLabelDesc}>{pillLabel}</span>}
      </div>
    </div>
  );
};
